import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import instituteContextReducer from "./slices/instituteContextSlice";
import notificationReducer from "./slices/notificationSlice";
import chatReducer from "./slices/chatSlice";
import permissionsReducer from "./slices/permissionsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    instituteContext: instituteContextReducer,
    notifications: notificationReducer,
    chat: chatReducer,
    permissions: permissionsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
